import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <p>Copyright ⓒ {year} By Rushikesh Biradar</p>
    </footer>
  );
}

export default Footer;
